/**
 * @generated SignedSource<<0ca1bde3fb68d0b0519d461111ceb93b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationStatus = "DISABLED" | "ENABLED" | "SUSPENDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IntegrationChoices_company$data = {
  readonly id: string;
  readonly rowId: any;
  readonly integrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly rowId: any;
        readonly kind: string;
        readonly config: any | null;
        readonly status: IntegrationStatus;
      };
    }>;
  };
  readonly organization: {
    readonly slug: string;
  } | null;
  readonly " $fragmentType": "IntegrationChoices_company";
};
export type IntegrationChoices_company$key = {
  readonly " $data"?: IntegrationChoices_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationChoices_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "integrations"
        ]
      }
    ]
  },
  "name": "IntegrationChoices_company",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": "integrations",
      "args": null,
      "concreteType": "IntegrationsConnection",
      "kind": "LinkedField",
      "name": "__IntegrationChoices_integrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Integration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "config",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "82f22e902b842ff67b68a90b3019b0d6";

export default node;
